import { createFileRoute } from "@tanstack/react-router";

import { TopupPage } from "@/features/money/pages";

export const Route = createFileRoute("/_app/money/topups/$topupId")({
  component: Topup,
});

function Topup() {
  const { topupId } = Route.useParams();
  return <TopupPage key={topupId} topupId={topupId} />;
}
